<template>
  <div>
    <div class="sls-title">
      <div>{{ $t("RAM.ALI.Sls.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="['resourceConfigurationManagement:ali:sls:update']"
          :loading="loading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          v-hasPermission="['resourceConfigurationManagement:ali:sls:export']"
          :loading="modal_loading"
          @click="exportList"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <div class="sls-top">
      <sls-search ref="child"></sls-search>
    </div>
    <table-sls></table-sls>
    <export ref="exportChild"></export>
  </div>
</template>

<script>
import SlsSearch from "./SlsSearch";
import TableSls from "./TableSls";
import Export from "../Export";

export default {
  name: "Sls",
  components: {
    SlsSearch,
    TableSls,
    Export
  },
  data() {
    return {
      loading: false,
      modal_loading: false,
      companyId: ""
    };
  },
  methods: {
    update: function() {
      this.loading = true;
      this.companyId = this.$refs.child.companyId;
      this.$api.resourceManagement
        .updateResource({
          companyId: this.companyId,
          resourceManagement: 303,
          accountType: 1
        })
        .then(res => {
          this.loading = false;
          setTimeout(() => {
            this.$Message.success(this.$t('common.updateSuccess'));
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      var exportDTO = {
        companyId: this.$refs.child.companyId,
        accountIdList: this.$refs.child.accountIdList,
        projectName: this.$refs.child.projectName
      };
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: this.$t('common.exporting')
      });
      // 下载Excel 文件
      this.$api.resourceManagement.exportAliSls(exportDTO).then(res => {
        let fileName = "Sls.xls";
        let blob = new Blob([res.data], { type: "application/x-xls" });
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(link.href);
        }
        this.modal_loading = false;
        this.$Message.destroy();
        this.$Message.success(this.$t('common.exportSuccess'));
      });
    }
  }
};
</script>

<style scoped>
.sls-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  overflow: hidden;
  font-weight: 600;
}
.sls-title > div:nth-child(1) {
  float: left;
}
.sls-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.sls-top {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/ali/sls/Sls.vue